

const defaultState = () => ({
  title: 'Three Billboards',
  isLoading: false,
  currentUserKey: '',
  infoToggle: true,
});

export const mainState = (state = defaultState(), { action, types }) => {
  if (!types) return state;

  switch (action.type) {
  case types.toggleInfo:
    return { ...state, infoToggle: !state.infoToggle };
  case types.toggleInfoRequest:
    return { ...state };
  case types.setAccountRequet:
    return { ...state, isLoading: true };
  case types.setAccount:
    return { ...state, currentUserKey: action.userKey, isLoading: false };

  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/main/data/reducers.js